class Entity {
    id = null;
    name = '';
    registration_date = null;
    address = '';
    post_code = '';
    country_id = null;
    entity_type_id = null;
    active = true;
    notes = '';
    poc_name = '';
    poc_phone = '';
    poc_email = '';
    poc_cc = '';
    vat_option_id = 3;
    vat_exemption_comment = '';
    vat_id = '';
    vat_percentage = 0;
    bank_account_name = '';
    bank_name = '';
    bank_country_id = null;
    iban = '';
    swift = '';
    routing_number = '';
    account_holder = '';
    due_days = 0;
    invoice_notes = '';
    contract_header = '';
    pay_until = '';
    town = '';

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default Entity;
